import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "ic-empty-state-landing-page",
	templateUrl: "./empty-state-landing-page.component.html",
	styleUrls: ["./empty-state-landing-page.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class EmptyStateLandingPageComponent {
	/** The label to add on the page. */
	@Input() label: string;
	/** The label to add on the button. */
	@Input() buttonLabel: string;

	/** Button visible when listening to this emitter. */
	@Output() buttonCLick = new EventEmitter<void>();
}
